import { motion } from 'framer-motion';
import { CreditCard, Users, Calendar } from 'lucide-react';

export default function MembershipInfo() {
    return (
        <section className="py-16 bg-primary-50">
            <div className="container mx-auto px-6">
                <div className="max-w-4xl mx-auto">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-serif font-bold text-primary-900 mb-4">Envie de nous rejoindre ?</h2>
                        <div className="w-20 h-1 bg-accent-500 mx-auto rounded-full mb-6"></div>
                        <p className="text-gray-600 max-w-2xl mx-auto">
                            Participez à nos activités à la carte ou abonnez-vous pour profiter de toutes nos conférences.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {/* Option 1: Per Session */}
                        <div className="bg-white p-8 rounded-2xl shadow-sm border border-primary-100 hover:shadow-md transition-shadow">
                            <div className="flex items-center gap-4 mb-6">
                                <div className="p-3 bg-primary-100 rounded-xl text-primary-600">
                                    <Calendar size={24} />
                                </div>
                                <h3 className="text-xl font-bold text-primary-900">À la séance</h3>
                            </div>
                            <div className="mb-4">
                                <span className="text-4xl font-bold text-primary-900">5€</span>
                                <span className="text-gray-500"> / conférence</span>
                            </div>
                            <p className="text-gray-600">
                                Paiement sur place. Idéal pour découvrir nos activités ponctuellement.
                            </p>
                        </div>

                        {/* Option 2: Subscription */}
                        <div className="bg-white p-8 rounded-2xl shadow-md border border-primary-100 hover:shadow-lg transition-shadow relative overflow-hidden">
                            {/* Recommandé badge removed */}
                            <div className="flex items-center gap-4 mb-6">
                                <div className="p-3 bg-accent-100 rounded-xl text-accent-600">
                                    <Users size={24} />
                                </div>
                                <h3 className="text-xl font-bold text-primary-900">Abonnement</h3>
                            </div>
                            <div className="mb-4 flex flex-col">
                                <span className="text-4xl font-bold text-primary-900">40€</span>
                                <span className="text-gray-500">par personne</span>
                                <div className="mt-2 text-sm text-gray-500 font-medium">
                                    ou <span className="text-primary-900 font-bold text-lg">70€</span> par couple
                                </div>
                            </div>
                            <p className="text-gray-600 mb-6">
                                Accès aux 16 conférences jusque fin juin 2026.
                            </p>

                            <div className="pt-6 border-t border-gray-100">
                                <div className="flex items-start gap-3">
                                    <CreditCard size={20} className="text-primary-400 mt-1" />
                                    <div>
                                        <p className="text-sm text-gray-500 mb-1">Compte de l'UTA Barvaux :</p>
                                        <p className="font-mono font-medium text-primary-900 tracking-wide select-all">
                                            BE27 2500 2154 2573
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
